/* VISTA RÁPIDA — elegir talla y añadir desde la rejilla · 27-ago-2026
 *
 * El porqué de la interacción está en `avora-rapido.css`. Aquí van las
 * decisiones de comportamiento.
 *
 * 🔴 EL PANEL SE CONSTRUYE AL PRIMER TOQUE, no al cargar. Cincuenta y cuatro
 * tarjetas por cuatro tallas son doscientos botones que casi nadie abre; en el
 * catálogo eso se paga en el hilo principal justo cuando la clienta empieza a
 * hacer scroll. Construir uno al tocarlo cuesta menos de un cuadro.
 *
 * 🔴 UNA SOLA VISTA RÁPIDA ABIERTA. Abrir la de otra prenda cierra la anterior:
 * dos paneles abiertos en la misma rejilla se leen como un fallo, no como una
 * función.
 *
 * ⚠️ NO ABRE LA BOLSA al añadir. Ver el porqué en el CSS.
 */
(function () {
  'use strict';

  var abierta = null;                 /* la tarjeta con el panel desplegado */
  var RELOJ_HECHO = 1400;             /* lo que dura el "Añadido" en pantalla */

  function quieto() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* "S:123,M:124," → [{t:'S', id:'123'}, …]. El formato lo escribe
     `avora-pieza.liquid`; si algún día cambia, cambia en los dos sitios. */
  function variantes(pieza) {
    return (pieza.getAttribute('data-variantes') || '')
      .split(',')
      .filter(Boolean)
      .map(function (par) {
        var p = par.split(':');
        return { t: p[0], id: p[1] };
      })
      .filter(function (v) { return v.t && v.id; });
  }

  function cierra() {
    if (!abierta) return;
    abierta.removeAttribute('data-rapido-abierto');
    var b = abierta.querySelector('[data-rapido]');
    if (b) b.setAttribute('aria-expanded', 'false');
    abierta = null;
  }

  /* ── AÑADIR ────────────────────────────────────────────────────────────
     🔴 EL VUELO SALE AL TOCAR, NO AL CONTESTAR LA RED. Es la misma decisión
     que en la ficha: es lo único que puede empezar de inmediato y es justo lo
     que tiene que hacerlo — el acuse de que el toque se registró. Esperar a
     `/cart/add.js` deja medio segundo de nada y luego todo junto.
     Si la petición falla, el vuelo ya salió; por eso el fallo NO se traga: la
     tarjeta lo dice y manda a la ficha, que es el camino que siempre funciona. */
  function agrega(pieza, boton, id) {
    boton.setAttribute('data-yendo', '');

    if (window.AvoraVuelo) {
      var foto = pieza.querySelector('.p-pieza__foto');
      var bolsa = document.querySelector('.a-header__bolsa');
      if (foto && bolsa) AvoraVuelo.lanza(foto, bolsa);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return r.json();
      })
      .then(function () {
        /* 🔴 SE AVISA, NO SE ESCRIBE EL NÚMERO. `avora-cajon.js` es el único
           que manda sobre la cuenta de la cabecera: releerla desde aquí
           también sería tener dos verdades que se desincronizan. Ya pasó una
           vez —la ficha lo hacía por su cuenta y llevaba semanas sin acertar,
           sin un solo error en consola. */
        document.dispatchEvent(new CustomEvent('avora:bolsa'));

        cierra();
        pieza.setAttribute('data-rapido-hecho', '');
        setTimeout(function () {
          pieza.removeAttribute('data-rapido-hecho');
        }, RELOJ_HECHO);
      })
      .catch(function () {
        /* Sin red o con la variante ya agotada, la clienta va a la ficha: ahí
           está el formulario de verdad y el mensaje de Shopify si no hay stock.
           Quedarse con un botón que no hizo nada es la peor salida. */
        var enlace = pieza.querySelector('a[href]');
        if (enlace) window.location.href = enlace.getAttribute('href');
      })
      .then(function () {
        boton.removeAttribute('data-yendo');
      });
  }

  function abre(pieza, boton) {
    var vars = variantes(pieza);
    if (!vars.length) return;

    /* Unitalla: no hay nada que elegir, así que preguntar sería un paso de más
       para llegar al mismo sitio. Se añade y ya. */
    if (vars.length === 1) {
      agrega(pieza, boton, vars[0].id);
      return;
    }

    if (abierta && abierta !== pieza) cierra();

    var panel = pieza.querySelector('.p-tallas');
    if (!panel) {
      var capa = pieza.querySelector('.p-capa');
      if (!capa) return;

      panel = document.createElement('div');
      panel.className = 'p-tallas';
      /* El grupo se nombra con la prenda: con cincuenta y cuatro paneles
         iguales, un lector de pantalla leería "Talla S" cincuenta y cuatro
         veces sin saber de qué prenda. Es la misma razón que en el corazón. */
      panel.setAttribute('role', 'group');
      panel.setAttribute('aria-label', 'Tallas de ' + (pieza.getAttribute('data-nombre') || 'esta prenda'));

      vars.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'p-talla';
        b.textContent = v.t;
        b.addEventListener('click', function () { agrega(pieza, b, v.id); });
        panel.appendChild(b);
      });

      var hecho = document.createElement('p');
      hecho.className = 'p-hecho';
      hecho.setAttribute('aria-live', 'polite');   /* se anuncia sin robar foco */
      hecho.textContent = 'Añadido a tu bolsa';
      capa.appendChild(panel);
      capa.appendChild(hecho);
    }

    pieza.setAttribute('data-rapido-abierto', '');
    boton.setAttribute('aria-expanded', 'true');
    abierta = pieza;

    /* El foco va a la primera talla: quien llegó con el teclado ya está donde
       tiene que estar, y quien tocó con el dedo no nota nada. */
    if (!quieto()) {
      var primera = panel.querySelector('.p-talla');
      if (primera) primera.focus({ preventScroll: true });
    }
  }

  function enciende(pieza) {
    var boton = pieza.querySelector('[data-rapido]');
    if (!boton || !variantes(pieza).length) return;

    /* 🔴 LA CAPA SE CREA AQUÍ Y EL BOTÓN SE MUDA DENTRO. El Liquid lo imprime
       como hermano del enlace —un `<button>` dentro de un `<a>` es HTML
       inválido— pero ahí se posiciona contra la tarjeta ENTERA, nombre y
       precio incluidos, y el botón salía flotando junto al precio en vez de
       sobre la foto. Se vio en la primera captura del 27-ago.
       La capa calca la caja de la foto (misma `aspect-ratio`, ver el CSS) y
       sigue siendo hermana del enlace, así que el HTML se mantiene válido. */
    var capa = document.createElement('div');
    capa.className = 'p-capa';
    pieza.appendChild(capa);
    capa.appendChild(boton);

    boton.hidden = false;
    boton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (pieza.hasAttribute('data-rapido-abierto')) cierra();
      else abre(pieza, boton);
    });
  }

  function barre(raiz) {
    [].slice.call((raiz || document).querySelectorAll('.p-pieza[data-variantes]'))
      .forEach(function (p) {
        if (p.hasAttribute('data-rapido-listo')) return;
        p.setAttribute('data-rapido-listo', '');
        enciende(p);
      });
  }

  barre(document);

  /* 🔴 LAS PRENDAS DE LA PÁGINA 2 LLEGAN DESPUÉS. `avora-plp.js` pega el resto
     del catálogo cuando termina de traerlo; sin volver a barrer, esas tarjetas
     se quedarían con el botón apagado y la clienta vería la mitad de la
     rejilla con vista rápida y la otra mitad sin ella. */
  var muro = document.querySelector('[data-muro]');
  if (muro && window.MutationObserver) {
    new MutationObserver(function () { barre(muro); })
      .observe(muro, { childList: true });
  }

  /* Tocar fuera cierra: es lo que todo el mundo intenta antes de buscar la
     equis. Se escucha en captura para no pelear con el enlace de la tarjeta. */
  document.addEventListener('click', function (e) {
    if (!abierta) return;
    if (!abierta.contains(e.target)) cierra();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !abierta) return;
    var boton = abierta.querySelector('[data-rapido]');
    cierra();
    if (boton) boton.focus();     /* el foco vuelve de donde salió */
  });
})();
